// removed by extract-text-webpack-plugin
module.exports = {"attachment-container":"attachment-container","file-list":"file-list"};


//////////////////
// WEBPACK FOOTER
// ./components/conversations/_attachments.scss
// module id = ./components/conversations/_attachments.scss
// module chunks = 0